
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.VisualStudio.Services.Feed.Server.Plugins
// Microsoft.VisualStudio.Services.Packaging.CrossProtocol.Internal.WebApi
//----------------------------------------------------------

/// <amd-module name="Feed/Common/Contracts/WebPage" />
import VSS_Platform_Contracts_Identities = require("VSS/Platform/Contracts/Identities");
import __Feed = require("./Feed");

export enum UnfollowResultStatus {
    unfollowFailed = 0,
    unfollowSuccess = 1,
}

export module UpstreamConstants {
    export const InternalLocationScheme = "azure-feed";
}

export module WebPageConstants {
    export const DirectUpstreamSourceIdForThisFeedFilter = "00000000-0000-0000-0000-000000000000";
}

/**
* Any additional data to return with the feed message.
*/
export interface AdditionalFeedMessageData {
    /**
    * Status and details for each failing upstream source.
    */
    upstreamStatuses: UpstreamHealthStatus[];
}

export interface FeedBuildIdentity {
    descriptor: VSS_Platform_Contracts_Identities.IdentityDescriptor;
    displayName: string;
    id: string;
}

export interface FeedMessage {
    /**
    * Id of the feed message. Consists of the message id and the feed id combined with the minus (-) sign. E.g. MessageId-feedId
    */
    id: string;
    /**
    * Visible text of the optional link.
    */
    linkText: string;
    /**
    * Link URL.
    */
    linkUrl: string;
    /**
    * The message that is displayed in the feed UI
    */
    message: string;
    /**
    * The type of the message shown to the user in the UI.
    */
    messageType: MessageType;
}

export interface FeedMessageData {
    /**
    * Additional data to be returned with FeedMessagesDataProvider.
    */
    additionalData: AdditionalFeedMessageData;
    /**
    * List of feed messages. Ideally there shouldn't be too many messages so that the UI experience won't degrade.
    */
    messages: FeedMessage[];
}

export enum FeedRetrievalResult {
    Error = 0,
    NotFound = 1,
    NoFeeds = 2,
    Success = 3,
}

export interface FeedsResult {
    errorMessage: string;
    feeds: __Feed.Feed[];
    feedViews: __Feed.FeedView[];
    result: FeedRetrievalResult;
    selectedFeed: __Feed.Feed;
}

/**
* The type of the message shown to the user in the UI.
*/
export enum MessageType {
    Error = 0,
    Info = 1,
}

export interface NotifyOfPackagesIngestedInUpstreamsParameters {
    /**
    * List of feeds in the current collection that need to be refreshed as a result of the ingestion
    */
    downstreamFeeds: string[];
    /**
    * Name of the package to be refreshed
    */
    packageName: string;
    /**
    * Information used to support telemetry including end-to-end timings
    */
    pushDrivenUpstreamsTelemetry: any;
}

export interface PackageDetailsResult {
    errorMessage: string;
    package: __Feed.Package;
    packageVersion: __Feed.PackageVersion;
    result: PackageDetailsRetrievalResult;
}

export enum PackageDetailsRetrievalResult {
    Error = 0,
    NotFound = 1,
    Success = 2,
    NotFoundWithSamePackageCase = 3,
    NotFoundWithSameVersionCase = 4,
}

export interface PackagesResult {
    errorMessage: string;
    packages: __Feed.Package[];
    requestedPackageCount: number;
    result: PackagesRetrievalResult;
}

export enum PackagesRetrievalResult {
    Error = 0,
    NoPackages = 1,
    Success = 2,
}

export interface StatusDetails {
    /**
    * Category of the upstream source status.
    */
    statusCategory: UpstreamStatusCategory;
    /**
    * Timestamp of the status type.
    */
    timeStamp: Date;
}

export interface UpstreamHealthStatus {
    /**
    * The status we are confident about. This is the status from either a full upstream refresh or a category we know affects the whole upstream source.
    */
    confidentStatus: StatusDetails;
    /**
    * The status since the latest ConfidentStatus that isn't the same as ConfidentStatus. Empty if the status is the same as ConfidentStatus.
    */
    partialStatus: StatusDetails;
    /**
    * The id of the upstream source
    */
    upstreamId: string;
}

export enum UpstreamStatusCategory {
    /**
    * A full refresh succeeded and the feed is now OK. Partial refresh success is not stored.
    */
    FullRefreshSuccess = 0,
    /**
    * A full refresh was cancelled. This status should never get recorded in storage.
    */
    Aborted = 1,
    /**
    * An internal upstream's target view now has too low visibility. This is a total failure of the upstream.
    */
    TargetViewInsufficientVisibility = 2,
    /**
    * An internal upstream's target view has been deleted. This is a total failure of the upstream.
    */
    TargetViewDeleted = 3,
    /**
    * An internal upstream's target view's base feed has been deleted. This is a total failure of the upstream.
    */
    TargetFeedDeleted = 4,
    /**
    * An internal upstream's target view's base feed is project scoped and the project has been deleted. This is a total failure of the upstream.
    */
    TargetProjectDeleted = 5,
    /**
    * An error occurred while retrieving the content of a file from the upstream during ingestion. This is a package-level failure.
    */
    IngestDownloadFailure = 6,
    /**
    * An error occurred while processing a file from the upstream during ingestion. This is a package-level failure.
    */
    IngestProcessingFailure = 7,
    /**
    * Custom public upstream failure. This is considered a total failure of the upstream.
    */
    CustomPublicUpstreamFailure = 8,
    /**
    * Public upstream source is failing. This is a failure of the upstream.
    */
    PublicUpstreamFailure = 9,
    /**
    * An error occurred that we could not categorize to any known scenario.
    */
    UnknownFailure = 10,
    /**
    * A cross-org upstream has been deleted or customer no longer has access. This is considered a total failure in the upstream.
    */
    TargetOrganizationInaccessible = 11,
    /**
    * Custom public upstream failure where upstream has duplicate versions for the same package. This is considered a total failure of the upstream.
    */
    CustomPublicUpstreamFailure_DuplicatePackageVersions = 12,
    /**
    * Connecting to a cross-org upstream with a service connection failed.  This is a failure of the upstream.
    */
    TargetOrganizationServiceConnectionFailure = 13,
}

export interface WebPageData {
    batchOperationPageSize: number;
    collectionBuildIdentity: FeedBuildIdentity;
    currentUserDescriptor: string;
    defaultPublicUpstreamSources: __Feed.UpstreamSource[];
    enabledFeatures: string[];
    everyoneGroup: VSS_Platform_Contracts_Identities.IdentityDescriptor;
    everyoneGroupId: string;
    feedsResult: FeedsResult;
    isOrgAadBacked: boolean;
    minimumSnapshotInstanceCount: number;
    packageDetailsResult: PackageDetailsResult;
    packagesResult: PackagesResult;
    pageSize: number;
    projectBuildIdentity: FeedBuildIdentity;
    projectCollectionAdminGroupId: string;
    publicAccessMapping: string;
    recycleBinPackagesResult: PackagesResult;
    retentionPolicyCountLimitDefault: number;
    retentionPolicyDaysToKeepLimitDefault: number;
    retentionPolicyMaximumCountLimit: number;
    retentionPolicyMaximumDaysToKeepLimit: number;
    retentionPolicyMinimumCountLimit: number;
    retentionPolicyMinimumDaysToKeepLimit: number;
    upstreamSourceLimit: number;
    userCanAdministerFeeds: boolean;
    userCanCreateFeed: boolean;
}

